<template>
  <v-container>
    <div style="margin: auto; text-align: center!important">
      <h2 style="color: #fff!important;">{{ strings[idioma].ultimas_postagens }}</h2>
    </div>

    <v-layout>
      <v-card style="background: #fff; padding: 20px; border-radius: 20px; margin: auto;">
        <template v-if="($vuetify.breakpoint.width < 1200)">
          <v-layout wrap>
            <template v-for="post in posts">
              <v-flex xs12>
                <a
                  :href="post.link"
                  target="_blank"><img
                    :src="post._embedded['wp:featuredmedia']['0'].source_url"
                    style="height: 70px; width: 70px;"></a>
              </v-flex>
              <v-flex xs12>
                <a
                    :href="post.link"
                    target="_blank"><span style="font-size: 15pt;">{{ post.title.rendered }}</span></a>
              </v-flex>
            </template>
          </v-layout>
        </template>
        <v-list
          v-else-if="($vuetify.breakpoint.width >= 1200)"
          two-line
          dense
          flat
          rounded>
          <template v-for="post in posts">
            <v-list-tile
              v-if="post.status === 'publish' && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'].length > 0 && post._embedded['wp:featuredmedia']['0'].source_url"
              :key="post.id"
              :style="$vuetify.breakpoint.width >= 1200 ? 'height: 100px; padding: 10px; max-width: 970px' : 'height: 100px; padding: 10px; max-width: 400px' "
              flat>

              <v-list-tile-avatar style="padding: 10px;">
                <a
                  :href="post.link"
                  target="_blank"><img
                    :src="post._embedded['wp:featuredmedia']['0'].source_url"
                    style="height: 70px; width: 70px;"></a>
              </v-list-tile-avatar>
              <v-list-tile-content style="height: 100px;padding-left: 20px;">
                <v-list-tile-title>
                  <a
                    :href="post.link"

                    target="_blank"><span style="font-size: 15pt;">{{ post.title.rendered }}</span></a>
                </v-list-tile-title>

                <div
                  v-show="$vuetify.breakpoint.width >= 1200"
                  style="font-size: 8pt!important;"
                  @click="go(post.link)"
                  v-html="post.excerpt.rendered"/>

              </v-list-tile-content>

              <v-divider/>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      background: 'img/drawer-bg.jpg',
      logo: 'img/br-corte-logobranca.png',
      posts: []
      // img/br-corte-logobranca.png
    }
  },
  computed: {
    ...mapState('app', [
      'strings',
      'idioma'])
  },
  created () {
    this.getPosts()
  },
  methods: {
    getPosts () {
      return this.axios.get('https://brcorte.com.br/blog/wp-json/wp/v2/posts?per_page=3&_embed').then(r => { this.posts = r.data; return this.posts })
    },
    go (url) {
      window.location.href = url
    }
  }
}
</script>
